// 比較ビューの localStorage 履歴（最大 10 件）を保存・描画する。
// 詳細: .spec/DESIGN-tier4-b-tier2-polish.md §4-1
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return;
  if (window._compareHistoryInit) return;
  window._compareHistoryInit = true;

  var STORAGE_KEY = 'aiseki:compare:history:v1';
  var MAX_ENTRIES = 10;

  function isValidEntry(e) {
    return e && Array.isArray(e.ids) && e.ids.length >= 2 && e.ids.length <= 3 &&
           Array.isArray(e.names) && e.names.length === e.ids.length &&
           typeof e.at === 'number';
  }

  function readHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data) ? data.filter(isValidEntry) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(entries) {
    try {
      var trimmed = entries.slice(0, MAX_ENTRIES);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) { /* QuotaExceeded / private mode */ }
  }

  function recordCurrent() {
    var data = document.querySelector('[data-compare-snapshot]');
    if (!data) return;
    var ids = (data.dataset.ids || '').split(',').map(function (x) { return Number(x); }).filter(Boolean);
    var names = [];
    try { names = JSON.parse(data.dataset.names || '[]'); }
    catch (e) { names = []; }
    if (ids.length < 2 || names.length !== ids.length) return;
    var entry = { ids: ids, names: names, at: Math.floor(Date.now() / 1000) };
    var key = ids.slice().sort(function (a, b) { return a - b; }).join(',');
    var hist = readHistory().filter(function (e) {
      var k = e.ids.slice().sort(function (a, b) { return a - b; }).join(',');
      return k !== key;
    });
    hist.unshift(entry);
    writeHistory(hist);
  }

  function renderHistory() {
    var container = document.querySelector('[data-compare-history]');
    if (!container) return;
    var hist = readHistory();
    if (hist.length === 0) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var list = container.querySelector('ul');
    if (!list) return;
    list.innerHTML = '';
    hist.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/stores/compare?branch_ids=' + e.ids.join(',');
      a.textContent = e.names.join(' / ');
      a.setAttribute('data-gtm-event', 'compare_history_click');
      a.setAttribute('data-gtm-count', String(e.ids.length));
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    recordCurrent();
    renderHistory();
  });
})();
